function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.551)",
  fill: "#D23214",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  y: 15.551,
  width: 31,
  height: 6,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(45 25.392 12)",
  x: 12.392,
  y: 9,
  width: 26,
  height: 6,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  transform: "scale(-1 1) rotate(45 0 -33.804)",
  x: 12,
  y: 23.551,
  width: 26,
  height: 6,
  rx: 2
}));

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzZweCIgaGVpZ2h0PSIzN3B4IiB2aWV3Qm94PSIwIDAgMzYgMzciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5Hcm91cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC0wLjU1MTQzMSkiIGZpbGw9IiNEMjMyMTQiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIxNS41NTE0MzEzIiB3aWR0aD0iMzEiIGhlaWdodD0iNiIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUuMzkxNjc0LCAxMi4wMDAwMDApIHJvdGF0ZSg0NS4wMDAwMDApIHRyYW5zbGF0ZSgtMjUuMzkxNjc0LCAtMTIuMDAwMDAwKSAiIHg9IjEyLjM5MTY3NDMiIHk9IjkiIHdpZHRoPSIyNiIgaGVpZ2h0PSI2IiByeD0iMiI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNS4wMDAwMDAsIDI2LjU1MTQzMSkgc2NhbGUoLTEsIDEpIHJvdGF0ZSg0NS4wMDAwMDApIHRyYW5zbGF0ZSgtMjUuMDAwMDAwLCAtMjYuNTUxNDMxKSAiIHg9IjEyIiB5PSIyMy41NTE0MzEzIiB3aWR0aD0iMjYiIGhlaWdodD0iNiIgcng9IjIiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgArrow as ReactComponent };